import React from 'react';

// Home page section titles (2026-10-15, "Token scale"): a short Manrope title
// on the text-h2 token with one muted description line under it. No italic or
// two-tone emphasis. `display` steps the title up to text-display.
export function HomeTitle({ title, desc, dark, display, className = '' }) {
  return (
    <div className={className}>
      <h2
        className={`text-balance font-headline ${display ? 'text-display' : 'text-h2'} ${
          dark ? 'text-press-paper' : 'text-press-ink'
        }`}
      >
        {title}
      </h2>
      {desc && (
        <p className={`mt-1.5 text-desc ${dark ? 'text-press-paper/70' : 'text-press-muted'}`}>{desc}</p>
      )}
    </div>
  );
}
